import React from "react";
import type { Ok } from "@ps-bridge/ok";
import type { StateUpdate } from "@ps-bridge/capabilitiesTypes";
import type { ClientsViewProps } from "@ps-bridge/contracts/clients";
import type { Project } from "@ps-bridge/models/core/dataContracts";
import * as IO from "@ps-bridge/interop/io";
import ProjectsPanel, {
  type ProjectsPanelEmptyResultPhase,
  type ProjectsPanelToolbarPhase,
} from "@view/panels/workspace/clients/ProjectsPanel.panel";

type ProjectsPanelContractProps = Pick<
  ClientsViewProps,
  "projects" | "activeProjectId" | "activeClientId" | "onNavigateProject"
>;

type ProjectsPanelViewProps = ProjectsPanelContractProps & {
  filteredProjects: Project[];
  clientQuery: string;
  projectNameOptions: string[];
  projectEmptyText: string;
  onClientQueryChange: StateUpdate<string>;
  onCreateProject: () => Ok;
  onOpenProjectMenu: (payload: {
    event: React.MouseEvent<HTMLButtonElement>;
    project: Project;
  }) => Ok;
  runIO: typeof IO.run;
  formatTime: (value: string) => string;
};

const ProjectsPanelView: React.FC<ProjectsPanelViewProps> = ({
  projects,
  filteredProjects,
  activeProjectId,
  activeClientId,
  clientQuery,
  projectNameOptions,
  projectEmptyText,
  onClientQueryChange,
  onCreateProject,
  onNavigateProject,
  onOpenProjectMenu,
  runIO,
  formatTime,
}) => {
  const toolbarPhase: ProjectsPanelToolbarPhase =
    projects.length === 0 ? "empty" : "search";
  const emptyResultPhase: ProjectsPanelEmptyResultPhase =
    filteredProjects.length === 0 && projects.length > 0 ? "visible" : "hidden";

  return (
    <ProjectsPanel
      projects={projects}
      filteredProjects={filteredProjects}
      activeProjectId={activeProjectId}
      activeClientId={activeClientId}
      clientQuery={clientQuery}
      projectNameOptions={projectNameOptions}
      projectEmptyText={projectEmptyText}
      toolbarPhase={toolbarPhase}
      emptyResultPhase={emptyResultPhase}
      onClientQueryChange={onClientQueryChange}
      onCreateProject={onCreateProject}
      onNavigateProject={onNavigateProject}
      onOpenProjectMenu={onOpenProjectMenu}
      runIO={runIO}
      formatTime={formatTime}
    />
  );
};

export default ProjectsPanelView;
